export const isAuthenticated = () => {
  const token = localStorage.getItem("jwt");
  if (!token) {
    return null;
  }
  return token;
};
